<template>
  <div class="ping">
    <div class="ping-signal flex-align-center">
      <p class="ping-signal-name text-min">
        {{ $t("common.ping.nodeSignal") }}
      </p>
      <div class="ping-signal-icon flex">
        <div :class="isSignalHave(5)"></div>
        <div :class="isSignalHave(35)"></div>
        <div :class="isSignalHave(65)"></div>
        <div :class="isSignalHave(100)"></div>
        <div :class="isSignalHave(500)"></div>
      </div>
      <p class="ping-data-text text-min">{{ dataVal }}kb/s</p>
    </div>
  </div>
</template>
<script>
import Ping from "ping.js";

export default {
  name: "ping",
  data() {
    return {
      dataVal: "0",
      setIntervalP: null,
    };
  },
  props: {
    value: {
      type: String,
      default: window.location.origin,
    },
  },
  methods: {
    isSignalHave(val) {
      return Number(this.dataVal) > val ? "signal-have" : "";
    },
  },
  mounted() {
    const p = new Ping();
    this.setIntervalP = setInterval(() => {
      // Using callback
      p.ping(this.value, (err, data) => {
        if (err) {
          console.log("error loading resource");
          data = 0;
        }

        this.dataVal = data;
      });
    }, 2000);
  },
  destroyed() {
    clearInterval(this.setIntervalP);
  },
};
</script>
<style lang="scss" scoped>
.ping {
  box-sizing: border-box;
  width: 170px;
  height: 100%;
  font-size: 12px;
  pointer-events: none;
  .ping-signal {
    width: 100%;

    .ping-signal-name {
      opacity: 0.5;
      margin-right: 12px;
    }
    .ping-signal-icon {
      margin-right: 8px;
      width: 20px;
      align-items: flex-end;

      div {
        width: 3px;
        margin-left: 1px;
        $height: 2px;
        background: #414345;
        &:nth-child(n) {
          height: 2px;
        }
        &:nth-child(2) {
          height: 5px;
        }
        &:nth-child(3) {
          height: 8px;
        }
        &:nth-child(4) {
          height: 11px;
        }
        &:nth-child(5) {
          height: 14px;
        }

        &.signal-have {
          background: #a6f616;
        }
      }
    }
  }
  .ping-data {
    width: 100%;
    .ping-data-name {
      opacity: 0.5;
    }

    .ping-data-text {
      text-align: right;
      line-height: 16px;
      font-weight: 400;
    }
  }
}
</style>
